export default function Configure($stateProvider) {
    $stateProvider.state('refsaisie', {
        parent: 'common',
        url: '/refsaisie',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.SAISIES" | translate }}'
        }
    });

    $stateProvider.state('refsaisie.list', {
        url: '/list',
        template: '<trames-saisies></trames-saisies>',
        rights: { domain: 'refsaisie', right: 'read' },
        ncyBreadcrumb: {
            parent: 'refsaisie',
            label: '{{ "TRAMES.BREADCRUMBS.TRAMES_LIST" | translate}}'
        },
        navigation: {
            menu: 'laboratoire_donnees',
            translate: 'TRAMES.BREADCRUMBS.TRAMES_LIST',
            order: 5
        },
        search: 'TRAMES.BREADCRUMBS.TRAMES_LIST'
    });

    $stateProvider.state('refsaisie.list.detail', {
        url: '/{id}',
        template: '<trame-saisie-detail></trame-saisie-detail>',
        rights: { domain: 'refsaisie', right: 'read' },
        ncyBreadcrumb: {
            parent: 'refsaisie.list',
            label: '{{ "TRAMES.BREADCRUMBS.TRAME_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('refsaisie.new', {
        url: '/new',
        template: '<trame-saisie-form></trame-saisie-form>',
        rights: { domain: 'refsaisie', right: 'create' },
        ncyBreadcrumb: {
            parent: 'refsaisie.list',
            label: '{{ "TRAMES.BREADCRUMBS.TRAME_NEW" | translate}}'
        },
        search: 'TRAMES.BREADCRUMBS.TRAME_NEW'
    });

    $stateProvider.state('refsaisie.edit', {
        url: '/{id}/edit',
        template: '<trame-saisie-form></trame-saisie-form>',
        rights: { domain: 'refsaisie', right: 'update' },
        ncyBreadcrumb: {
            parent: 'refsaisie.list',
            label: '{{ "TRAMES.BREADCRUMBS.TRAME_EDIT" | translate }}'
        }
    });

    $stateProvider.state('refsaisie.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: { parentState: 'refsaisie.new' },
        ncyBreadcrumb: {
            parent: 'refsaisie.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });

    $stateProvider.state('refsaisie.duplicate', {
        url: '/{id}/duplicate',
        template: '<trame-saisie-form></trame-saisie-form>',
        rights: { domain: 'refsaisie', right: 'create' },
        ncyBreadcrumb: {
            parent: 'refsaisie.list',
            label: '{{ "TRAMES.BREADCRUMBS.TRAME_NEW" | translate}}'
        },
        params: {
            duplicate: true
        }
    });
}

Configure.$inject = ['$stateProvider'];
